import { render } from "./oficialiaMinutario.vue?vue&type=template&id=cda2c59e"
import script from "./oficialiaMinutario.vue?vue&type=script&lang=js"
export * from "./oficialiaMinutario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__